import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

export default function MasterKeyModal({ open, onOpenChange, onUnlocked, reason }) {
  const { unlockMaster } = useAuth();
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!pwd) return;
    setLoading(true);
    try {
      await unlockMaster(pwd);
      toast.success("Senha mestra desbloqueada para esta sessão");
      setPwd("");
      onOpenChange(false);
      if (onUnlocked) onUnlocked();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Senha mestra incorreta");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border" data-testid="master-key-modal">
        <DialogHeader>
          <div className="size-10 rounded bg-primary/10 flex items-center justify-center mb-2">
            <ShieldAlert className="size-5 text-primary" />
          </div>
          <DialogTitle>Desbloquear sessão mestra</DialogTitle>
          <DialogDescription>
            {reason || "Esta operação requer descriptografia de dados sensíveis. Informe sua senha mestra de administrador."}
            {" "}A chave fica em memória pelo tempo da sessão (8h) ou até bloquear manualmente.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input
            type="password"
            placeholder="Senha mestra"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            data-testid="master-password-input"
            autoFocus
          />
          <Button type="submit" disabled={loading || !pwd} className="w-full" data-testid="master-unlock-submit">
            {loading ? "Desbloqueando..." : "Desbloquear"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
